import { render } from "./PublicFaq.vue?vue&type=template&id=e2749004&scoped=true"
import script from "./PublicFaq.vue?vue&type=script&lang=js"
export * from "./PublicFaq.vue?vue&type=script&lang=js"

import "./PublicFaq.vue?vue&type=style&index=0&id=e2749004&scoped=true&lang=scss"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2749004"]])

export default __exports__